<template>
  <div>
    <div class="footermessage" :class="{ v2: apiVersion === 'v2'}">
      <div class="footermessage__content">
        <div class="footermessage__text" v-html="$t(message_text)"></div>
      </div>
      <div class="inputCheckbox" v-if="checkEnabled">
        <input
          class="inputCheckbox__input"
          id="footermessage__check"
          type="checkbox"
          v-model="checkAcepted"
          v-show="!readonly"
        />
        <label class="inputCheckbox__label" for="footermessage__check">
          <span class="inputCheckbox__legend">{{ $t(acceptMessage) }}</span>
          <span class="inputCheckbox__check">
            <i class="fas fa-check"></i>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FooterMessage',
  props: {
    checkEnabled: {
      required: true,
      type: Boolean
    },
    value: {
      default: false,
      required: false,
      type: Boolean
    },
    readonly: {
      default: false,
      required: false,
      type: Boolean
    },
    message_text: {
      default: 'bottom_message_text',
      required: false,
      type: String
    },
    acceptMessage: {
      default: 'bottom_message_check_accept',
      required: false,
      type: String
    },
    apiVersion: {
      default: 'v1',
      type: String
    }
  },
  data () {
    return {
      checkAcepted: false
    }
  },
  mounted() {
    this.checkAcepted = this.value
  },
  watch: {
    checkAcepted: function (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="sass">
.footermessage
  background: var(--color-overlay-05)
  border-radius: var(--b-radius-md)
  margin-top: 2rem
  font-family: var(--font-family-sans-serif)
  color: var(--color-onSurface)
  &__content
    padding: 1rem
  &__title
    font-size: var(--font-size-md)
    overflow: hidden
  &__text
    font-size: var(--font-size-base)
    p
      img
        width: auto
        height: auto
        max-width: 100%
  .inputCheckbox
    padding: 1rem
    border-top: 1px solid var(--color-overlay-10)
    justify-content: flex-end
    &__check
      margin: 0 0 0 1rem
    &__legend
      text-align: right
      color: var(--color-onBackground)

.footermessage.v2
  background: none
  .footermessage__content
    padding: 1rem 0
  .inputCheckbox
    border-radius: var(--b-radius-md)
    background: var(--color-overlay-05)
    border: none
    justify-content: flex-start
    &__label
      flex-direction: row-reverse
    &__check
      margin: 0
    &__legend
      margin: 0 0 0 1rem
@media (max-width: 768px)
  .footermessage.v2
    background: none
    margin-bottom: 5rem      
</style>
